// import transakSDK from "@transak/transak-sdk";
import { TransakConfig, Transak } from "@transak/transak-sdk";

/**
 * Initializes the Transak configuration object.
 *
 * @param user - The user object.
 * @param address - The user's wallet address.
 * @param fiatAmount - The amount in fiat currency.
 * @param fiatCurrency - The fiat currency code.
 * @param cryptoCurrency - Optional. The cryptocurrency code.
 * @returns The Transak configuration object.
 */
export function initTransak(
  user: any,
  address: string | any,
  fiatAmount: number,
  fiatCurrency: string,
  cryptoCurrency?: string,
  cryptoAmount?: number
) {
  // console.log("user", user);
  const userKyc = JSON.parse(user?.userDriverKYC);
  // console.log("userKyc?", userKyc?.id_info);

  const transakConfig: TransakConfig = {
    apiKey: process.env.REACT_APP_TRANSAK_STAGING_API_KEY as string,
    environment:
      process.env.REACT_APP_TRANSAK_ENV === "staging"
        ? Transak.ENVIRONMENTS.STAGING
        : Transak.ENVIRONMENTS.PRODUCTION,
    // productsAvailed: ["buy", "sell", "fiat_onramp", "crypto_onramp", "swap"],
    // productsAvailed: "BUY,SELL",
    productsAvailed: "BUY",
    widgetHeight: "80%",
    defaultFiatAmount: 1000,
    defaultFiatCurrency: "USD",
    defaultNetwork: "polygon",
    defaultPaymentMethod: "credit_debit_card",
    defaultCryptoCurrency: "MATIC",
    themeColor: "#215759",
    walletAddress: address as string,
    disableWalletAddressForm: true,
    userData: {
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      mobileNumber: user?.phone,
      dob: userKyc?.id_info?.birth_date,
      address: {
        addressLine1:
          userKyc?.id_info?.address?.parsed_address?.address_street_1,
        addressLine2:
          userKyc?.id_info?.address?.parsed_address?.address_street_2,
        city: userKyc?.id_info?.address?.parsed_address?.address_city,
        state: userKyc?.id_info?.address?.parsed_address?.address_state,
        postCode: userKyc?.id_info?.address?.parsed_address?.address_zip_code,
        countryCode: userKyc?.id_info?.address?.parsed_address?.address_country,
      },
    },
    fiatCurrency: fiatCurrency,
    fiatAmount: fiatAmount,
    network: "polygon",
    cryptoCurrencyCode: cryptoCurrency ?? "USDC",
    isFeeCalculationHidden: true,
    hideExchangeScreen: true,
    email: user?.email,
    isAutoFillUserData: true,
    hideMenu: true,
    cryptoAmount: cryptoAmount,
  };

  return transakConfig;
}

export function initTransakOffRamp(
  user: any,
  address: string | any,
  cryptoAmount: number,
  fiatCurrency: string,
  cryptoCurrency?: string
) {
  // console.log("user", user);
  const userKyc = JSON.parse(user?.userDriverKYC);
  // console.log("userKyc?", userKyc?.id_info);

  const transakConfig: TransakConfig = {
    apiKey: process.env.REACT_APP_TRANSAK_STAGING_API_KEY as string,
    environment: Transak.ENVIRONMENTS.STAGING,
    // productsAvailed: ["buy", "sell", "fiat_onramp", "crypto_onramp", "swap"],
    productsAvailed: "SELL",
    widgetHeight: "90%",
    defaultFiatAmount: 1000,
    defaultFiatCurrency: "USD",
    defaultNetwork: "polygon",
    defaultPaymentMethod: "credit_debit_card",
    defaultCryptoCurrency: "MATIC",
    themeColor: "#215759",
    walletAddress: address as string,
    disableWalletAddressForm: true,
    userData: {
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      mobileNumber: user?.phone,
      dob: userKyc?.id_info?.birth_date,
      address: {
        addressLine1:
          userKyc?.id_info?.address?.parsed_address?.address_street_1,
        addressLine2:
          userKyc?.id_info?.address?.parsed_address?.address_street_2,
        city: userKyc?.id_info?.address?.parsed_address?.address_city,
        state: userKyc?.id_info?.address?.parsed_address?.address_state,
        postCode: userKyc?.id_info?.address?.parsed_address?.address_zip_code,
        countryCode: userKyc?.id_info?.address?.parsed_address?.address_country,
      },
    },
    fiatCurrency: fiatCurrency,
    // fiatAmount: fiatAmount,
    network: "polygon",
    cryptoCurrencyCode: cryptoCurrency ?? "USDC",
    isFeeCalculationHidden: true,
    hideExchangeScreen: true,
    email: user?.email,
    isAutoFillUserData: true,
    hideMenu: true,
    cryptoAmount: cryptoAmount,
  };

  return transakConfig;
}
export const transakConfig: TransakConfig = {
  apiKey: process.env.REACT_APP_TRANSAK_STAGING_API_KEY as string,
  environment: Transak.ENVIRONMENTS.STAGING,
  // productsAvailed: ["buy", "sell", "fiat_onramp", "crypto_onramp", "swap"],
  productsAvailed: "SELL",
  widgetHeight: "90%",
  defaultFiatAmount: 1000,
  defaultFiatCurrency: "USD",
  defaultNetwork: "polygon",
  defaultPaymentMethod: "credit_debit_card",
  defaultCryptoCurrency: "MATIC",
  themeColor: "#215759",
  walletAddress: "0x18B8fdfa7349EEad63d41d2c68cf124eBE0270E4",
  disableWalletAddressForm: true,
};
